import { render, staticRenderFns } from "./SellAssignedAppliance.vue?vue&type=template&id=2067200c&scoped=true"
import script from "./SellAssignedAppliance.vue?vue&type=script&lang=js"
export * from "./SellAssignedAppliance.vue?vue&type=script&lang=js"
import style0 from "./SellAssignedAppliance.vue?vue&type=style&index=0&id=2067200c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067200c",
  null
  
)

export default component.exports